import React from 'react';

import { t } from '../../../../../utils/i18-next';
import { CameraType } from '../../../../../viewer/cameras/types';
import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { WmsTool } from '../../../../../viewer/tools/wms-tool';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { RightPanelHeader } from '../../../skyview/right-menu/components/right-menu-header';
import { Stack } from '../../../stack/stack';
import { WmsLayerSelectionList } from './wms-layer-selection-list';

interface Props {
  wmsTool: WmsTool;
}

export const WmsToolMenu = ({ wmsTool }: Props) => {
  useSubscribe(SubscriptionTopic.OnCameraChanged, (message) => {
    const cameraType = message.camera.cameraType;
    if (cameraType !== CameraType.OrthographicCamera) {
      InputHandler.instance.unsetTool('wms', 'select');
    }
  });

  return (
    <Stack direction="column" spacing={0}>
      <RightPanelHeader
        icon={['fal', 'map']}
        name={t('wms.tool.layers.title', { ns: 'skyview' })}
      />
      <WmsLayerSelectionList wmsTool={wmsTool} />
    </Stack>
  );
};
